/**
 * Utility to detect AbortErrors from navigation-based request cancellation.
 * These errors are expected behavior and should be filtered out from error reporting.
 */

export function isAbortError(error: any): boolean {
  if (!error) {
    return false
  }

  // Get error message from various possible locations
  const errorMessage = error.message || error?.data?.message || ''
  const errorName = error.name || error?.data?.name || ''

  return (
    errorName === 'AbortError' ||
    errorMessage.includes('AbortError') ||
    errorMessage.includes('aborted') ||
    errorMessage.includes('Fetch is aborted') ||
    errorMessage.includes('The operation was aborted') ||
    errorMessage.includes('The user aborted a request')
  )
}

/**
 * Utility to detect AbortErrors from XState machine events.
 * Machine events have a different structure with nested data.
 */
export function isAbortErrorFromEvent(event: any): boolean {
  if (!event) {
    return false
  }

  return isAbortError(event) || isAbortError(event.data)
}
